import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import AddLazyLoadingToAllImages from "./addlazyloadingtoallimages"

export default class ImageLazyLoading extends Plugin {
  static get requires() {
    return [AddLazyLoadingToAllImages]
  }
}
